const action = {
    general: 'Beim Ausführen der Aktion ist ein Fehler aufgetreten. Versuchen Sie es später erneut.',
    sign_in_identifier_changed: 'Die Aktion kann die für diese Verifizierung verwendete Anmeldekennung nicht ändern.',
};
export default Object.freeze(action);
